import styled from 'styled-components';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 22px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Container = styled.div`
  align-items: center;
  background-color: #2243d9;
  display: flex;
  height: 68px;
`;
Container.displayName = 'Container';

export const Logo = styled.img`
  margin-left: 17px;
`;
Logo.displayName = 'Logo';

export const PointsAway = styled.div`
  color: #ffffff;
  right: 45px;
  position: relative;
  top: 3px;
  width: 14px;
`;
PointsAway.displayName = 'PointsAway';

export const PointsContainer = styled.div`
  align-items: center;
  background: #ffffff;
  display: flex;
  height: 100%;
`;
PointsContainer.displayName = 'PointsContainer';

export const Points = styled.div`
  color: #132c8b;
  margin: 0 26px;
  min-width: 60px;
  text-align: center;
`;
Points.displayName = 'Points';

export const PointsSeparator = styled.div`
  background: #4b75d9;
  height: calc(100% - 20px);
  width: 4px;
`;
PointsSeparator.displayName = 'PointsSeparator';

export const TeamName = styled.div`
  color: #ffffff;
  margin: 0 28px;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  color: #ffffff;
  margin: 0 50px;
  min-width: 145px;
`;
Timer.displayName = 'Timer';

export const Wrapper = styled.section`
  font-family: 'Inter', sans-serif;
  font-size: 48px;
  font-weight: 600;
  margin-top: 34px;
  transform: scale(0.8);
`;
Wrapper.displayName = 'Wrapper';
